export const SET_CONTACT = 'SET_CONTACT'
export const RESET_CONTACT = 'RESET_CONTACT'
